module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('ddHead', {
    attrs: {
      "title": _vm.titleName
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "profile_bg",
    attrs: {
      "src": _vm.info.bg_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "profile",
    class: {
      profile_nobg: _vm.isHaveBg
    }
  }, [_c('div', {
    staticClass: "headimg"
  }, [_c('img', {
    attrs: {
      "src": _vm.info.face_img,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user_name"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.info.nickname || '      '))]), _vm._v(" "), (_vm.info.customer_identity_url) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.info.customer_identity_url),
      expression: "info.customer_identity_url"
    }],
    staticClass: "user_link user_home",
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.info.gender != 0 ? './images/female.png' : './images/male.png',
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "follow"
  }, [_c('router-link', {
    staticClass: "follow_link",
    attrs: {
      "to": "myfollow",
      "dd_name": "关注人数"
    }
  }, [_vm._v("关注 " + _vm._s(_vm.followInfo.data.follow_count || 0) + " ")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('router-link', {
    staticClass: "follow_link",
    attrs: {
      "to": "myfans",
      "dd_name": "粉丝人数"
    }
  }, [_vm._v(" 粉丝 " + _vm._s(_vm.followInfo.data.fans_count || 0))])], 1), _vm._v(" "), _c('div', {
    staticClass: "introduce"
  }, [_c('p', {
    class: {
      omit: _vm.isOmit,
      textLeft: _vm.isTextLeft
    },
    on: {
      "click": _vm.openDesc
    }
  }, [_vm._v("简介：" + _vm._s(_vm.info.desc || '这位书友正在书海畅游，还没有编辑个人介绍。') + " ")])]), _vm._v(" "), (_vm.is_self) ? _c('router-link', {
    staticClass: "edit",
    attrs: {
      "to": {
        name: 'edit',
        params: {
          item: _vm.info
        }
      },
      "dd_name": "编辑"
    }
  }, [_c('div', {
    staticClass: "edit_icon"
  }), _vm._v("\n            编辑个人资料\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.is_focus) ? _c('div', {
    staticClass: "follow_button",
    attrs: {
      "dd_name": "关注"
    },
    on: {
      "click": _vm.followMe
    }
  }, [(!_vm.isFollow) ? _c('div', {
    staticClass: "no_concern"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/follow.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("关注")])]) : _c('div', {
    staticClass: "aleady_concernd"
  }, [_vm._v("已关注")])]) : _vm._e(), _vm._v(" "), (_vm.info.show === 'enabled') ? _c('ul', {
    staticClass: "contact"
  }, [(_vm.info.qq) ? _c('li', [_c('div', {
    staticClass: "qq_bg"
  }), _vm._v(" "), _c('p', {
    staticClass: "omit"
  }, [_vm._v(_vm._s(_vm.info.qq))])]) : _vm._e(), _vm._v(" "), (_vm.info.weixin) ? _c('li', [_c('div', {
    staticClass: "wechat_bg"
  }), _vm._v(" "), _c('p', {
    staticClass: "omit"
  }, [_vm._v(_vm._s(_vm.info.weixin))])]) : _vm._e(), _vm._v(" "), (_vm.info.email) ? _c('li', [_c('div', {
    staticClass: "email_bg"
  }), _vm._v(" "), _c('p', {
    staticClass: "omit"
  }, [_vm._v(_vm._s(_vm.info.email))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "book_info"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("我要出书")]), _vm._v(" "), (_vm.isHaveBookInfo) ? _c('div', {
    staticClass: "book_info_contain"
  }, _vm._l((_vm.bookInfoList), function(item) {
    return _c('bookinfo-item', {
      key: item.bookId,
      attrs: {
        "content": item,
        "is_self": _vm.is_self
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "book_info_btn"
  }, [(_vm.is_self) ? [(_vm.is_self) ? _c('a', {
    staticClass: "info_btn",
    attrs: {
      "href": _vm.myBookListUrl,
      "dd_name": " isHaveBookInfo? '全部作品' : '我关注的作品' "
    }
  }, [_vm._v(_vm._s(_vm.isHaveBookInfo ? '全部作品' : '我关注的作品'))]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.is_self) ? [(_vm.is_self) ? _c('a', {
    staticClass: "info_btn",
    attrs: {
      "href": _vm.myBookListUrl,
      "dd_name": " isHaveBookInfo? '全部作品' : '看看Ta关注的作品' "
    }
  }, [_vm._v(_vm._s(_vm.isHaveBookInfo ? '全部作品' : '看看Ta关注的作品'))]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "book_comment"
  }, [_c('h2', [_vm._v("短书评（" + _vm._s(_vm.commentList.totalNum || 0) + "）")]), _vm._v(" "), (!_vm.isHaveBookComment) ? _c('div', {
    staticClass: "book_comment_contain"
  }, [_vm._l((_vm.commentList.data), function(item) {
    return _c('book-comment', {
      key: item.id,
      attrs: {
        "content": item,
        "comment-type": 0
      }
    })
  }), _vm._v(" "), (_vm.commentList.totalNum > 3) ? _c('router-link', {
    staticClass: "book_comment_button",
    attrs: {
      "to": {
        name: 'bookcommentList',
        params: {
          comment_type: 0
        }
      },
      "dd_name": "全部短书评"
    }
  }, [_vm._v(" 全部短书评" + _vm._s(_vm.commentList.totalNum) + "条")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isHaveBookComment) ? _c('div', {
    staticClass: "no_comment"
  }, [_vm._v(_vm._s(_vm.isHaveBookComment))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "book_comment"
  }, [_c('h2', [_vm._v("长书评（" + _vm._s(_vm.commentLongList.totalNum || 0) + "）")]), _vm._v(" "), (!_vm.isHaveLongBookComment) ? _c('div', {
    staticClass: "book_comment_contain"
  }, [_vm._l((_vm.commentLongList.data), function(item) {
    return _c('book-comment', {
      key: item.id,
      attrs: {
        "content": item,
        "comment-type": 1
      }
    })
  }), _vm._v(" "), (_vm.commentLongList.totalNum > 3) ? _c('router-link', {
    staticClass: "book_comment_button",
    attrs: {
      "to": {
        name: 'bookcommentList',
        params: {
          comment_type: 1
        }
      },
      "dd_name": "全部长书评"
    }
  }, [_vm._v(" 全部长书评" + _vm._s(_vm.commentLongList.totalNum) + "条")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isHaveLongBookComment) ? _c('div', {
    staticClass: "no_comment"
  }, [_vm._v(_vm._s(_vm.isHaveLongBookComment))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "book_list"
  }, [_c('h2', [_vm._v("书单（" + _vm._s(_vm.bookList.pageInfo.total || 0) + "）")]), _vm._v(" "), (!_vm.isHaveBookList) ? _c('div', {
    staticClass: "book_list_contain"
  }, [_vm._l((_vm.bookList.result), function(item) {
    return _c('booklist-item', {
      key: item.id,
      attrs: {
        "conent": item
      }
    })
  }), _vm._v(" "), (_vm.bookList.pageInfo.total > 3) ? _c('router-link', {
    staticClass: "book_comment_button",
    attrs: {
      "to": "bookList",
      "dd_name": "全部书单"
    }
  }, [_vm._v(" 全部书单" + _vm._s(_vm.bookList.pageInfo.total) + "个")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isHaveBookList) ? _c('div', {
    staticClass: "no_comment"
  }, [_vm._v(_vm._s(_vm.isHaveBookList))]) : _vm._e()]), _vm._v(" "), (_vm.isComplete) ? _c('div', {
    staticClass: "send_email"
  }, [_c('p', [_vm._v("申请成为书评人或者组建书评团")]), _vm._v(" "), _c('p', [_vm._v("请联系ddshequ@dangdang.com")])]) : _vm._e(), _vm._v(" "), (_vm.errobj.type) ? _c('popup', {
    attrs: {
      "pop-obj": _vm.errobj
    },
    on: {
      "confirm-click": _vm.confirmEvent
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-078fb950"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage.vue
// module id = 212
// module chunks = 3